var map = {
	"./DROP_DOWN.svg": 298,
	"./ic_arbitrum_16.svg": 812,
	"./ic_avalanche_16.svg": 813,
	"./ic_avax_40.svg": 475,
	"./ic_bnb_40.svg": 476,
	"./ic_btc_40.svg": 330,
	"./ic_coingecko_16.svg": 814,
	"./ic_convert_down.svg": 815,
	"./ic_copy_16.svg": 341,
	"./ic_eth_40.svg": 331,
	"./ic_frax_40.svg": 477,
	"./ic_glp_24.svg": 478,
	"./ic_glp_40.svg": 479,
	"./ic_link_40.svg": 480,
	"./ic_metamask_16.svg": 816,
	"./ic_mim_40.svg": 481,
	"./ic_new_link_16.svg": 342,
	"./ic_settings_16.svg": 343,
	"./ic_sign in_16.svg": 817,
	"./ic_sign_out_16.svg": 344,
	"./ic_uni_40.svg": 482,
	"./ic_usdc.e_40.svg": 483,
	"./ic_usdc_40.svg": 484,
	"./ic_usdt_40.svg": 485,
	"./ic_wavax_40.svg": 486,
	"./ic_wbnb_40.svg": 487,
	"./ic_weth_40.svg": 488,
	"./long.svg": 345,
	"./short.svg": 346,
	"./swap.svg": 347,
	"./wave-01.png": 818
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 811;